import $ from 'jquery';

$(function() {
    $('.navbar-toggle').on('click', function() {
        let menu = $('.nav__menu');
        let body = $('body');
        menu.toggleClass('active');
        if (menu.hasClass('active')) {
            window.body_scroll_position = $(window).scrollTop();
            menu.slideDown(function () {
                body.css('position', 'fixed');
                body.css('overflow', 'hidden');
            });
        } else {
            body.css('position', '');
            body.css('overflow', '');
            $(window).scrollTop(window.body_scroll_position);
            menu.slideUp();
        }
    });

    var elements = $('[data-viewheight]');
    elements.each(function () {
      $(this).css('height', (window.innerHeight / 100) * $(this).data('viewheight'));
    });

    $('.dropdown-menu-toggler').on('click', function () {
        let dropdownmenu = $(this).parent().parent().find('.dropdown-menu');

        $('.dropdown-menu.active').not(dropdownmenu).each(function() {
            $(this).slideUp();
            $(this).removeClass('active');
            $(this).prev().find('.normal').fadeIn();
            $(this).prev().find('.toggled').fadeOut();
        });

        $(this).find('.normal').fadeToggle();
        $(this).find('.toggled').fadeToggle();
        dropdownmenu.slideToggle();
        dropdownmenu.addClass('active');
    });
});
